import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'
import { useFlexFlagIsOn } from '@indeed/flex-feature-flags'

import AgencyViewBody from 'syft-acp-core/entities2/AgencyView'
import PageTitle, { recordLabel, useAgencyName } from 'syft-acp-core/components/PageTitle'
import { AgencySubNavigation } from './AgencySubNavigation'

export const AgencyView = ({ match: { params }, ...props }) => {
  const isAgencyRateCardEnabled = useFlexFlagIsOn('pte_16679_agency_rate_cards')
  const agencyName = useAgencyName(Number(params.id))

  return (
    <TrackingProvider
      value={{
        context: {
          agency_id: Number(params.id),
        },
      }}
    >
      <PageTitle title={[recordLabel('Agency', params.id, agencyName)]}>
        {isAgencyRateCardEnabled && (
          <AgencySubNavigation agencyID={Number(params.id)} agencyName={agencyName} />
        )}
        <AgencyViewBody params={params} {...props} />
      </PageTitle>
    </TrackingProvider>
  )
}

AgencyView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.string }).isRequired,
  }),
  isAgencyRateCardEnabled: PropTypes.bool.isRequired,
}
